import { useLocalize } from 'localize-react';
import React, { useMemo } from 'react';

import styles from './quoteScoreBadge.module.scss';

interface QuoteScoreBadgeProps {
  score: number;
  reviews: number;
}

const QuoteScoreBadge: React.FC<QuoteScoreBadgeProps> = ({ reviews, score }) => {
  const { translate: t } = useLocalize();
  const roundedScore = Math.round(score * 10) / 10;

  const label = useMemo(() => {
    if (roundedScore >= 9.5) {
      return t('quoteScoreBadge_label_Exceptional');
    }
    if (roundedScore >= 9.0) {
      return t('quoteScoreBadge_label_Superb');
    }
    if (roundedScore >= 8.5) {
      return t('quoteScoreBadge_label_VeryGood');
    }
    if (roundedScore >= 8.0) {
      return t('quoteScoreBadge_label_Good');
    }
    return t('quoteScoreBadge_label_NotBad');
  }, [roundedScore]);

  return (
    <div className={styles.container}>
      <div className={styles.scoreBox}>
        <span className={styles.score}>{roundedScore}</span>
      </div>
      <div className={styles.textContainer}>
        <span className={styles.title}>{label}</span>
        <span className={styles.subtitle}>{t('quoteScoreBadge_label_reviews', { reviews })}</span>
      </div>
    </div>
  );
};

export default QuoteScoreBadge;
